const DocsFrame = () => {
  return (
    <>
      <iframe
        src="../../build_docs/index.html"
        style={{ width: '100%', height: '100vh', border: 'none' }}
        title="Documentation"
      />
    </>
  );
};

export default DocsFrame;
